import { render, staticRenderFns } from "./fastvaluedeal-faq.vue?vue&type=template&id=97d99cfc&scoped=true&"
import script from "./fastvaluedeal-faq.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-faq.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-faq.vue?vue&type=style&index=0&id=97d99cfc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d99cfc",
  null
  
)

export default component.exports